import { render, staticRenderFns } from "./TrucksRoad.vue?vue&type=template&id=f3b695d0&scoped=true"
import script from "./TrucksRoad.vue?vue&type=script&lang=js"
export * from "./TrucksRoad.vue?vue&type=script&lang=js"
import style0 from "./TrucksRoad.vue?vue&type=style&index=0&id=f3b695d0&prod&scoped=true&lang=scss"
import style1 from "./TrucksRoad.vue?vue&type=style&index=1&id=f3b695d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3b695d0",
  null
  
)

export default component.exports